import IdRequest from "./id_request"

export default class CheckoutRequest extends IdRequest {
  checkoutMode: number = 1
}
